<!--eslint-disable-->
<template>
  <div class="pricingScheme seller-style">
    <div class="box20"></div>
    <div class="b_white bor_radius_10">
      <div class="lin_75 f18 gray_3 pad30_l">添加价格方案</div>
      <div class="ps_main clear">
        <p class="ps_main_head">温馨提示：最终的价格，以商品列表计算后展示的价格为准</p>
        <div class="clear ps_search_wrap">
          <span class="float-left lin_30 inlineblock w70 gray_3">名称</span>
          <div class="ps_search float-left">
            <el-input type="text" placeholder="请输入价格方案" v-model="price.name" maxlength="10" show-word-limit> </el-input>
          </div>
        </div>
        <div class="box20"></div>
        <div class="clear">
          <span class="float-left lin_30 inlineblock w70 gray_3">类别</span>
          <div class="float-left ps_category lin_30">
            <el-radio v-model="price.schemeType" :label="1">按分组设置</el-radio>
            <el-radio v-model="price.schemeType" :label="2">按客户设置</el-radio>
            <!-- <ul class="clear">

              &lt;!&ndash;<li v-for="(item) in schemeTypeArray" :key="item.key"
                  :class="{category_active:item.key === price.schemeType}"
                  @click="price.schemeType = item.key">
                {{item.value}}
              </li>&ndash;&gt;
            </ul>-->
          </div>
        </div>
        <div class="box20"></div>
        <div v-if="price.schemeType === 1">
          <div class="clear pad70_l">
            <div class="ps_add" @click="chooseGroup">
              <i class="el-icon-plus"></i>
              添加分组
            </div>
          </div>
          <div class="ps_group_list pad70_l">
            <ul class="clear">
              <li v-for="(item, index) in groupShowList" :key="index">
                <i class="iconfont icon-shibai fb" @click="removeGroup(item)"></i>
                <p class="group_item_name ellipsis_two">{{ item.name }}</p>
                <p>人群总数：{{ item.customerNum }}</p>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="price.schemeType === 2">
          <div class="clear pad70_l">
            <div class="ps_add" @click="chooseCustomer">
              <i class="el-icon-plus"></i>
              添加客户
            </div>
          </div>
          <div class="ps_group_list pad70_l">
            <ul class="clear">
              <li v-for="(item, index) in customerShowList" :key="index">
                <i class="iconfont icon-shibai fb" @click="removeCustomer(item)"></i>
                <p class="group_item_name ellipsis_two">{{ item.name }}</p>
                <p>身份：{{ item.targetType === 1 ? "个人" : "企业" }}</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="clear">
          <span class="float-left lin_30 inlineblock w70 gray_3">选择货品</span>
          <div class="float-left ps_choose_goods lin_30">
            <el-radio v-model="price.goodsType" :label="11">全部货品</el-radio>
            <el-radio v-model="price.goodsType" :label="21">指定分类</el-radio>
            <el-radio v-model="price.goodsType" :label="31">指定货品</el-radio>
            <!-- <ul class="clear">
              <li v-for="(item) in goodsTypeArray" :key="item.key"
                  :class="{choose_goods_active:item.key === price.goodsType}"
                  @click="price.goodsType = item.key">
                {{item.value}}
              </li>
            </ul>-->
          </div>
        </div>
        <div class="box20"></div>
        <div class="pad70_l">
          <div class="ps_all_goods" v-if="price.goodsType === 11">
            <span class="gray_3">价格设置</span>
            <span class="pad15_l gray_9"
              >按原价<input type="text" min="0" maxlength="10" v-model="rebate" @input="rebate = formatPrice(rebate, 2)" />%，进行售卖
            </span>
          </div>
          <div v-if="price.goodsType === 21">
            <div class="clear">
              <!--<span class="float-left pad15_r lin_30 inlineblock w75">选择分类</span>-->
              <div class="ps_add" @click="chooseCategory">
                <i class="el-icon-plus"></i>
                选择分类
              </div>
            </div>
            <div class="box20"></div>
            <div class="ps_classify_list">
              <ul class="clear">
                <li class="ellipsis" v-for="(item, index) in categoryShowList" :key="index">
                  <span>{{ item.text }}</span>
                  <i class="iconfont icon-shibai fb" @click="removeCategory(item)"></i>
                </li>
              </ul>
              <div class="ps_all_goods">
                <span class="gray_3">价格设置</span>
                <span class="pad15_l gray_9"
                  >按原价<input type="text" min="0" maxlength="10" v-model="rebate" @input="rebate = formatPrice(rebate, 2)" />%，进行售卖
                </span>
              </div>
            </div>
          </div>
          <div v-if="price.goodsType === 31">
            <div class="ps_appoint_goods">
              <div class="ps_add" @click="chooseGoods">
                <i class="el-icon-plus"></i>
                添加货品
              </div>
            </div>
            <div class="modify_price_wrap" v-if="goodsPageTotalList.length > 0">
              <p>批量修改价格</p>
              <div class="lin_30 mar10_b">
                <el-radio-group v-model="modifyPriceRadio">
                  <el-radio :label="1">批量加减价格</el-radio>
                  <el-radio :label="2">按折扣修改价格</el-radio>
                </el-radio-group>
              </div>
              <div class="lin_30 mar10_b clear" v-if="modifyPriceRadio === 1">
                <p class="float-left"><el-input-number class="mar5_lr" maxlength="10" :precision="2" v-model="batch.price"></el-input-number> 元</p>
                <el-button class="float-left mar40_l modify_price_btn" type="primary" @click="batchConfirm">确 定</el-button>
              </div>
              <div class="lin_30 mar10_b clear" v-if="modifyPriceRadio === 2">
                <p class="float-left">
                  折扣价
                  <input class="mar5_lr" type="text" min="0" maxlength="10" v-model="batch.rebate" @input="batch.rebate = formatPrice(batch.rebate, 2)" />%
                </p>
                <el-button class="float-left mar40_l modify_price_btn" type="primary" @click="batchConfirm">确 定</el-button>
              </div>
            </div>
            <div class="box20"></div>
            <div v-if="goodsPageList && goodsPageList.length" class="flex items-center gray6 mar20-b f24">
              <el-tooltip effect="dark" content="列表展示" placement="top">
                <i class="el-icon-s-operation pointer" :class="{ blue: goodsShowStyle == 'table' }" @click="goodsShowStyle = 'table'"></i>
              </el-tooltip>
              <el-tooltip effect="dark" content="卡片展示" placement="top">
                <i class="el-icon-menu mar10-l pointer" :class="{ blue: goodsShowStyle == 'card' }" @click="goodsShowStyle = 'card'"></i>
              </el-tooltip>
              <el-button v-if="goodsShowStyle == 'table'" class="mar20-l" size="mini" type="primary" @click="batchDel">批量删除</el-button>
            </div>
            <el-table
              ref="goodsList"
              v-if="goodsPageList && goodsPageList.length && goodsShowStyle == 'table'"
              :header-cell-style="{ backgroundColor: '#f8f8f8' }"
              align="center"
              :data="goodsPageList"
              @selection-change="goodsListSelectionChange"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column prop="name" label="货品名称"> </el-table-column>
              <el-table-column label="货品图片">
                <template slot-scope="scope">
                  <el-image v-if="scope.row.picUrl" class="wh60" :preview-src-list="[scope.row.picUrl]" :src="`${scope.row.picUrl}?imageView2/1/w/60/h/60`" />
                  <img v-else class="wh60" src="@/assets/images/goods_small.jpg" />
                </template>
              </el-table-column>
              <el-table-column prop="spec" label="规格" width="200"> </el-table-column>
              <el-table-column prop="originalPrice" label="原价" width="200"> </el-table-column>
              <el-table-column label="方案价格" width="250">
                <template slot-scope="scope">
                  <input
                    style="width: 150px"
                    type="text"
                    min="0"
                    maxlength="15"
                    v-model="scope.row.price"
                    @input="scope.row.price = formatPrice(scope.row.price, 6)"
                  />
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100">
                <div class="blue pointer" slot-scope="scope" @click="removeGoods(scope.row)">删除</div>
              </el-table-column>
            </el-table>
            <div v-else class="appoint_goods_list">
              <ul class="clear">
                <li v-for="(item, index) in goodsPageList" :key="index">
                  <i class="iconfont icon-shibai fb" @click="removeGoods(item)"></i>
                  <el-image
                    class="float-left appoint_good_img"
                    v-if="item.picUrl"
                    :src="`${item.picUrl}?imageView2/1/w/80/h/80`"
                    :preview-src-list="[item.picUrl]"
                  />
                  <img class="float-left appoint_good_img" v-else src="@/assets/images/goods_small.jpg" alt="" />
                  <div class="float-left appoint_good_main">
                    <p class="ellipsis_two f14 gray_3" :title="item.name">{{ item.name }}</p>
                    <p class="f12 gray_6">规格：{{ item.spec }}</p>
                    <p class="f12 gray_6">原价：¥{{ item.originalPrice }}</p>
                    ¥ <input type="text" min="0" maxlength="15" v-model="item.price" @input="item.price = formatPrice(item.price, 6)" />
                  </div>
                </li>
              </ul>
            </div>
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :hide-on-single-page="totalCount <= pageSize"
              :current-page="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next, jumper"
              :total="totalCount"
            >
            </el-pagination>
          </div>
          <div class="box50"></div>
        </div>
        <div class="ps_footer t_center">
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" :disabled="disabled" @click="priceSubmit">确 认</el-button>
            <el-button @click="priceCancel">取 消</el-button>
          </span>
        </div>
      </div>
    </div>
    <!--选择分组弹框-->
    <el-dialog
      title="选择分组"
      :visible.sync="chooseGroupVisible"
      :close-on-click-modal="false"
      width="445px"
      :show-close="false"
      custom-class="chooseGroupPop"
    >
      <div class="ps_group_list">
        <ul class="clear">
          <!-- 组-->
          <li v-for="(item, index) in groupDataList" @click="groupDialogSelect(item)" :key="index" :class="{ chooseGroupLi: item.isActive }">
            <!--            <i class="iconfont icon-shibai fb"></i>-->
            <p class="group_item_name ellipsis_two">{{ item.name }}</p>
            <p>人群总数：{{ item.customerNum }}</p>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="groupDialogConfirm">确 认</el-button>
        <el-button @click="chooseGroupVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!--选择客户弹框-->
    <el-dialog
      title="选择客户"
      :visible.sync="chooseClientVisible"
      :close-on-click-modal="false"
      width="735px"
      :show-close="false"
      custom-class="chooseClientPop"
    >
      <div>
        <div class="clear ps_search_wrap">
          <span class="float-left pad15_r lin_30 inlineblock">客户名称</span>
          <div class="ps_search float-left">
            <el-input type="text" placeholder="请输入客户名称" v-model="searchCustomer.name"> </el-input>
          </div>
          <div class="float-left client_pop_query" @click="listCustomer(1)">搜索</div>
        </div>
        <div class="box30"></div>
        <div class="clear ps_search_wrap">
          <span class="float-left pad15_r lin_30 inlineblock">客户分组</span>
          <div class="ps_search float-left">
            <el-select v-model="searchCustomer.groupId" placeholder="请选择客户分组" clearable>
              <el-option v-for="item in groupDataList1" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </div>
        </div>
        <div class="box20"></div>
        <div class="clear ps_group_list">
          <div class="float-left client_list_all">
            <p>我的客户</p>
            <div class="client_list_pop_main">
              <ul class="clear">
                <!-- 客户-->
                <li v-for="(item, index) in customerDataList" :key="index" @click="customerDialogSelect(item)">
                  <!--                  :class="{chooseCustomerLi:item.isActive}"-->
                  <p class="group_item_name ellipsis_two">{{ item.name }}</p>
                  <p>身份：{{ item.targetType === 1 ? "个人" : "企业" }}</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="float-right client_list_me">
            <p>已选客户</p>
            <div class="client_list_pop_main">
              <ul class="clear">
                <li v-for="(item, index) in customerSelectList" :key="index">
                  <i class="iconfont icon-shibai fb" @click="removeSelectCustomer(item)"></i>
                  <p class="group_item_name ellipsis_two">{{ item.name }}</p>
                  <p>身份：{{ item.targetType === 1 ? "个人" : "企业" }}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="box20"></div>
      <el-pagination
        background
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
        :current-page="currentPage1"
        :page-sizes="[6, 20, 30]"
        :page-size="pageSize1"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount1"
      >
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="customerDialogConfirm">确 认</el-button>
        <el-button @click="customerDialogClose">取 消</el-button>
      </span>
    </el-dialog>
    <!--选择商品弹框-->
    <el-dialog
      title="选择商品"
      :visible.sync="chooseGoodVisible"
      :close-on-click-modal="false"
      width="945px"
      top="80px"
      :show-close="false"
      custom-class="chooseGoodPop"
    >
      <div>
        <div class="clear ps_search_wrap">
          <span class="float-left pad15_r lin_30 inlineblock gray_3">货品名称</span>
          <div class="ps_search float-left">
            <el-input type="text" placeholder="请输入货品名称" v-model="searchGoods.name"> </el-input>
          </div>
          <div class="float-left client_pop_query" @click="getPriceGoodsList(1)">搜索</div>
        </div>
        <div class="box30"></div>
        <div class="clear ps_search_wrap">
          <span class="float-left pad15_r lin_30 inlineblock gray_3">货品分类</span>
          <div class="ps_search float-left">
            <el-select v-model="searchGoods.axis" placeholder="请选择货品分类" clearable>
              <el-option v-for="item in backgroundCategoryList" :key="item.id" :label="item.text" :value="item.id"> </el-option>
            </el-select>
          </div>
        </div>
        <div class="box20"></div>
        <div class="clear appoint_goods_list">
          <div class="float-left client_list_all">
            <p class="gray_3">本店货品</p>
            <div class="client_list_wrap">
              <ul class="clear">
                <li v-for="(item, index) in goodsDataList" :key="index" @click="goodsDialogSelect(item)">
                  <img class="float-left appoint_good_img" v-if="item.picUrl" :src="item.picUrl" alt="" />
                  <img class="float-left appoint_good_img" v-else src="@/assets/images/goods_small.jpg" alt="" />
                  <div class="float-left appoint_good_main">
                    <p class="ellipsis_two f14 gray_3" :title="item.name">{{ item.name }}</p>
                    <p class="f12 gray_6">规格：{{ item.spec }}</p>
                    <p class="f12 gray_6">原价：¥{{ item.originalPrice }}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="float-right client_list_me">
            <p class="gray_3">已选货品</p>
            <div class="client_list_wrap">
              <ul class="clear">
                <li v-for="(item, index) in goodsSelectList" :key="index">
                  <i class="iconfont icon-shibai fb" @click="removeSelectGoods(item)"></i>
                  <img class="float-left appoint_good_img" v-if="item.picUrl" :src="item.picUrl" alt="" />
                  <img class="float-left appoint_good_img" v-else src="@/assets/images/goods_small.jpg" alt="" />
                  <div class="float-left appoint_good_main">
                    <p class="ellipsis_two f14 gray_3" :title="item.name">{{ item.name }}</p>
                    <p class="f12 gray_6">规格：{{ item.spec }}</p>
                    <p class="f12 gray_6">原价：¥{{ item.originalPrice }}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="box20"></div>
      </div>
      <el-pagination
        background
        @size-change="handleSizeChange2"
        @current-change="handleCurrentChange2"
        :current-page="currentPage2"
        :page-sizes="[10, 20, 30]"
        :page-size="pageSize2"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount2"
      >
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="goodsDialogConfirm">确 认</el-button>
        <el-button @click="goodsDialogClose">取 消</el-button>
      </span>
    </el-dialog>
    <!--批量修改价格弹框-->
    <!--    <el-dialog
      title="批量编辑"
      :visible.sync="batchEditorVisible"
      :close-on-click-modal="false"
      width="500px"
      :show-close="false"
      custom-class="batchEditorPop">
      <div>
        <div class="clear">
          <span class="float-left pad30_r lin_30 inlineblock">批量加、减价格</span>
          <div class="float-left">
            <input type="text" maxlength="10" v-model="batch.price" @input="batch.price = formatPrice(batch.price,2)"></input>
          </div>
        </div>
        <div class="box30"></div>
        <div>
          <span class="pad80_r">折扣价</span>
          <span>
            <input type="text" min="0" maxlength="10" v-model="batch.rebate" @input="batch.rebate = formatPrice(batch.rebate,2)"></input>%，折扣进行设置
          </span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="batchConfirm">确 认</el-button>
        <el-button @click="batchEditorVisible = false">取 消</el-button>
      </span>
    </el-dialog>-->
    <!--选择分类弹框-->
    <el-dialog title="全部分类" :visible.sync="chooseCategoryVisible" :close-on-click-modal="false" width="390px" custom-class="chooseClassifyPop">
      <div>
        <ul class="clear">
          <li v-for="(item, index) in categoryDataList" @click="categoryDialogSelect(item)" :key="index" :class="{ chooseClassifyActive: item.isActive }">
            {{ item.text }}
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="categoryDialogConfirm">确 认</el-button>
        <el-button @click="chooseCategoryVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      id: "", // 价格方案id
      shopId: "",
      price: {
        // 提交对象
        schemeType: 1, // 类别 1.按分组设置,2.按客户设置
        goodsType: 11, // '选择货品类型 11.全部货品,21.指定分类,31.指定货品
        schemeTypeList: [],
        memberPriceList: [],
      },
      schemeTypeArray: [
        { key: 1, value: "按分组设置" },
        { key: 2, value: "按客户设置" },
      ],
      goodsTypeArray: [
        { key: 11, value: "全部货品" },
        { key: 21, value: "指定分类" },
        { key: 31, value: "指定货品" },
      ],

      groupShowList: [], // 分组 展示
      customerShowList: [], // 客户 展示
      customerSelectList: [], // 客户选择 数据
      categoryShowList: [], // 分类 展示
      goodsPageList: [], // 商品 分页展示
      goodsPageTotalList: [], // 商品 分页总数据
      goodsSelectList: [], // 商品 选择

      groupDataList: [], // 分组 接口获取
      groupDataList1: [], // 分组 接口获取
      customerDataList: [], // 客户 接口获取
      categoryDataList: [], // 分类 接口获取
      backgroundCategoryList: [], // 后台分类 接口获取
      goodsDataList: [], // 商品 接口获取
      batch: {
        price: "",
        rebate: 100,
      },
      rebate: "",
      chooseGroupVisible: false,
      chooseClientVisible: false,
      chooseGoodVisible: false,
      batchEditorVisible: false,
      chooseCategoryVisible: false,
      searchCustomer: {
        name: "",
        phone: "",
        groupId: "",
        pageNum: 1,
        pageSize: 10,
      },
      searchGoods: {
        name: "",
        axis: "",
        shopId: "",
        groupId: "",
        pageNum: 1,
        pageSize: 10,
        status: "",
      },
      disabled: false,
      // 分页
      pageSize: 9,
      currentPage: 1,
      totalCount: 0,
      pageSize1: 6,
      currentPage1: 1,
      totalCount1: 0,
      pageSize2: 10,
      currentPage2: 1,
      totalCount2: 0,
      modifyPriceRadio: 1,

      goodsShowStyle: "table", // 货品展示形式
      goodsSelectedItems: [], // 货品选择项
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  created() {
    const { query } = this.$route;
    this.id = "";
    this.getShopDefault();
    this.$store.dispatch("priceScheme/queryShopClassify", this.$qs.stringify({})).then((data) => {
      if (data && data.shopClassifyList) {
        const category = [];
        data.shopClassifyList.forEach((item) => {
          category.push({
            id: item.shopDecorateId,
            rank: item.sortId,
            axis: item.axis,
            text: item.name,
          });
        });
        this.categoryDataList = category;
      }
      if (query && query.id) {
        this.id = query.id;
        this.getPriceSchemeDetail(query.id);
      }
    });
  },
  // 进入页面加载数据 -相当于jquery的ready
  mounted() {
    this.$nextTick(() => {
      // this.listCustomer();
    });
  },
  // 监听器
  filters: {},
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.localGoodsPageList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.localGoodsPageList();
    },
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.listCustomer();
    },
    handleCurrentChange1(val) {
      this.currentPage1 = val;
      this.listCustomer();
    },
    handleSizeChange2(val) {
      this.pageSize2 = val;
      this.getPriceGoodsList();
    },
    handleCurrentChange2(val) {
      this.currentPage2 = val;
      this.getPriceGoodsList();
    },
    // 本地分页
    localGoodsPageList() {
      const array = this.goodsPageTotalList || [];
      const pageNo = this.currentPage;
      const { pageSize } = this;
      const offset = (pageNo - 1) * pageSize;
      this.goodsPageList = offset + pageSize >= array.length ? array.slice(offset, array.length) : array.slice(offset, offset + pageSize);
      this.totalCount = array.length;
    },
    getShopDefault() {
      this.$store.dispatch("header/getShopDefault", {}).then((data) => {
        if (data && data.shopIdStr) {
          this.shopId = data.shopIdStr;
          this.getCustomerGroupList();
        }
      });
    },
    getCustomerGroupList() {
      const param = { shopId: this.shopId, priceSchemeId: this.id };
      this.$store.dispatch("priceScheme/getCustomerGroupList", this.$qs.stringify(param)).then((data) => {
        this.groupDataList1 = [];
        this.groupDataList = [];
        if (data) {
          this.groupDataList1 = data.groupList;
          data.filterGroupList.forEach((group) => {
            if (group.customerNum > 0) {
              this.groupDataList.push(group);
            }
          });
          console.log(this.groupDataList);
        }
      });
    },
    listCustomer(type) {
      const { searchCustomer } = this;
      searchCustomer.pageNum = this.currentPage1;
      searchCustomer.pageSize = this.pageSize1;
      if (type === 1) {
        // 搜索
        searchCustomer.pageNum = 1;
      }
      this.$store.dispatch("priceScheme/listCustomer", this.$qs.stringify(searchCustomer)).then((data) => {
        const newData = data || {};
        this.customerDataList = newData.data || [];
        this.totalCount1 = newData.count || 0;
        if (type === 2) {
          if (this.customerDataList.length === 0) {
            this.$message.error("无客户数据,请添加客户");
            return;
          }
          this.chooseClientVisible = true;
        }
      });
    },
    getCategory() {
      this.$store.dispatch("priceScheme/getCategory", this.$qs.stringify({})).then((data) => {
        if (data && data.categoryEntityList) {
          this.backgroundCategoryList = data.categoryEntityList;
        }
      });
    },
    // 1搜索  2选择货品
    getPriceGoodsList(type) {
      const { searchGoods } = this;
      searchGoods.pageNum = this.currentPage2;
      searchGoods.pageSize = this.pageSize2;
      searchGoods.shopId = this.shopId;
      if (type === 1) {
        // 搜索
        searchGoods.pageNum = 1;
      }
      this.$store.dispatch("priceScheme/priceGoodsList", this.$qs.stringify(searchGoods)).then((data) => {
        const newData = data || {};
        this.goodsDataList = newData.memberPriceVoList || [];
        this.totalCount2 = newData.totalCount || 0;
        if (type === 2) {
          if (this.goodsDataList.length === 0) {
            this.$message.error("无货品数据,请添加货品");
            return;
          }
          this.chooseGoodVisible = true;
        }
      });
    },
    // 页面交互事件
    // 点击添加分组
    chooseGroup() {
      if (this.groupDataList.length === 0) {
        this.$message.error("无分组数据,请添加客户分组");
        return;
      }
      this.chooseGroupVisible = true;
      this.groupDataList.forEach((group) => {
        const find = this.groupShowList.find((show) => show.schemeTypeValue === group.id);
        this.$set(group, "isActive", !!find);
      });
    },
    removeGroup(group) {
      this.groupShowList.splice(
        this.groupShowList.findIndex((show) => show.schemeTypeValue === group.schemeTypeValue),
        1
      );
    },
    // 组选择事件
    groupDialogSelect(group) {
      this.$set(group, "isActive", !group.isActive);
    },
    groupDialogConfirm() {
      const showList = [];
      this.groupDataList.forEach((group) => {
        if (group.isActive) {
          showList.push({
            name: group.name,
            customerNum: group.customerNum,
            schemeTypeValue: group.id,
          });
        }
      });
      this.groupShowList = showList;
      this.chooseGroupVisible = false;
    },
    // 点击添加客户
    chooseCustomer() {
      this.customerSelectList = Array.from(this.customerShowList);
      this.listCustomer(2);
    },
    // 组选择事件
    customerDialogSelect(customer) {
      this.checkCustom(customer);
    },
    // 删除已选择的客户
    removeSelectCustomer(customer) {
      this.customerSelectList.splice(
        this.customerSelectList.findIndex((item) => item.schemeTypeValue === customer.schemeTypeValue),
        1
      );
    },
    customerDialogConfirm() {
      this.customerShowList = Array.from(this.customerSelectList);
      this.customerDialogClose();
    },
    // 删除展示的客户
    removeCustomer(customer) {
      this.customerShowList.splice(
        this.customerShowList.findIndex((item) => item.schemeTypeValue === customer.schemeTypeValue),
        1
      );
    },
    customerDialogClose() {
      this.searchCustomer = {
        name: "",
        phone: "",
        groupId: "",
        pageNum: 1,
        pageSize: 10,
      };
      this.currentPage1 = 1;
      this.chooseClientVisible = false;
    },
    // 点击添加分类
    chooseCategory() {
      if (this.categoryDataList.length === 0) {
        this.$message.error("无分类数据,请添加店铺分类");
        return;
      }
      this.categoryDataList.forEach((category) => {
        const find = this.categoryShowList.find((show) => show.id === category.id);
        this.$set(category, "isActive", !!find);
      });
      this.chooseCategoryVisible = true;
    },
    removeCategory(category) {
      this.categoryShowList.splice(
        this.categoryShowList.findIndex((show) => show.id === category.id),
        1
      );
    },
    // 分类选择事件
    categoryDialogSelect(category) {
      this.$set(category, "isActive", !category.isActive);
    },
    categoryDialogConfirm() {
      const showList = [];
      this.categoryDataList.forEach((category) => {
        if (category.isActive) {
          showList.push({
            id: category.id,
            rank: category.rank,
            axis: category.axis,
            text: category.text,
          });
        }
      });
      this.categoryShowList = showList;
      this.chooseCategoryVisible = false;
    },
    // 点击添加商品
    chooseGoods() {
      this.goodsSelectList = Array.from(this.goodsPageTotalList);
      this.getCategory();
      this.getPriceGoodsList(2);
    },
    // 商品选择事件
    goodsDialogSelect(goods) {
      this.$set(goods, "isActive", !goods.isActive);
      const find = this.goodsSelectList.find((selectGoods) => selectGoods.goodsId === goods.goodsId);
      if (!find) {
        const assign = Object.assign({}, goods);
        this.goodsSelectList.push(assign);
        // this.handGoodsPrice(this.goodsSelectList);
      }

      console.log("goodsSelectListgoodsSelectList", this.goodsSelectList);
    },
    // 删除已选择的商品
    removeSelectGoods(goods) {
      this.goodsSelectList.splice(
        this.goodsSelectList.findIndex((item) => item.goodsId === goods.goodsId),
        1
      );
    },
    goodsDialogConfirm() {
      this.goodsPageTotalList = Array.from(this.goodsSelectList);
      this.localGoodsPageList();
      this.goodsDialogClose();
    },
    // 删除商品
    removeGoods(goods) {
      this.goodsPageTotalList.splice(
        this.goodsPageTotalList.findIndex((item) => item.goodsId === goods.goodsId),
        1
      );
      this.localGoodsPageList();
    },
    goodsDialogClose() {
      this.searchGoods = {};
      this.currentPage2 = 1;
      this.chooseGoodVisible = false;
    },
    // 取消价格方案
    priceCancel() {
      window.location.href = `${process.env.VUE_APP_APP}v/mj/priceScheme/list?appid=1&isShowTitle=1`;
    },
    // 批量修改价格
    batchConfirm() {
      const { price, rebate } = this.batch;
      // 初始默认值
      this.batch = {
        price: "",
        rebate: 100,
      };
      // 校验商品价格
      for (const goods of this.goodsPageTotalList) {
        let calculatePrice = parseFloat(goods.price);
        // 批量加减价格
        if (this.modifyPriceRadio === 1 && price && parseFloat(price) !== 0) {
          calculatePrice += parseFloat(price);
        }
        // 按折扣修改价格
        if (this.modifyPriceRadio === 2 && rebate && parseFloat(rebate) !== 100) {
          calculatePrice = (calculatePrice * parseFloat(rebate)) / 100;
        }
        const formatPrice = this.formatPrice(calculatePrice, goods.goodsPriceDigit, true);
        if (Number(formatPrice) <= 0) {
          this.$message.error("货品金额不能为0且不能为负数");
          return;
        }
        if (Number(formatPrice) >= Number(goods.originalPrice)) {
          this.$message.error(`价格方案金额不能大于等于货品原价(${goods.name})`);
          return;
        }
      }
      // 计算商品价格
      for (const goods of this.goodsPageTotalList) {
        let calculatePrice = parseFloat(goods.price);
        // 批量加减价格
        if (this.modifyPriceRadio === 1 && price && parseFloat(price) !== 0) {
          calculatePrice += parseFloat(price);
        }
        // 按折扣修改价格
        if (this.modifyPriceRadio === 2 && rebate && parseFloat(rebate) !== 100) {
          calculatePrice = (calculatePrice * parseFloat(rebate)) / 100;
        }
        const formatPrice = this.formatPrice(calculatePrice, goods.goodsPriceDigit);
        this.$set(goods, "price", formatPrice);
      }
      // 初始默认值
      this.batch = {
        price: "",
        rebate: 100,
      };
    },
    // 获取价格方案明细
    getPriceSchemeDetail(id) {
      this.$store.dispatch("priceScheme/getPriceSchemeDetail", this.$qs.stringify({ id })).then((data) => {
        if (!data) {
          return;
        }
        this.price = data;
        // 格式化小数位数
        this.goodsPageTotalList = data.memberPriceList || [];
        // this.handGoodsPrice(this.goodsPageTotalList);
        // 分页
        this.localGoodsPageList();
        // 分组设置
        if (data.schemeType === 1) {
          this.groupShowList = data.schemeTypeList || [];
        }
        // 按客户设置
        if (data.schemeType === 2) {
          this.customerShowList = data.schemeTypeList || [];
        }
        // 指定分类
        if (data.goodsType === 21) {
          const categoryList = [];
          const categoryIdArray = data.goodsTypeValue.split(",");
          categoryIdArray.forEach((categoryId) => {
            const find = this.categoryDataList.find((category) => categoryId === category.id.toString());
            if (find) {
              categoryList.push({
                id: find.id,
                rank: find.rank,
                axis: find.axis,
                text: find.text,
              });
            }
          });
          this.categoryShowList = categoryList;
        }
        // 折扣
        if (this.price.rebate) {
          this.rebate = this.price.rebate * 100;
        }
      });
    },
    // 提价价格方案
    priceSubmit() {
      // 必填项校验
      const priceVo = Object.assign({}, this.price);
      priceVo.shopId = this.shopId;
      if (!this.price.name) {
        this.$message.error("请输入名称");
        return;
      }
      // 分组设置
      if (priceVo.schemeType === 1) {
        if (!this.groupShowList || this.groupShowList.length === 0) {
          this.$message.error("请选择分组");
          return;
        }
        priceVo.schemeTypeList = this.groupShowList;
      }
      // 按客户设置
      if (priceVo.schemeType === 2) {
        if (!this.customerShowList || this.customerShowList.length === 0) {
          this.$message.error("请选择客户");
          return;
        }
        priceVo.schemeTypeList = this.customerShowList;
      }
      // 全部货品
      if (priceVo.goodsType === 11) {
        priceVo.goodsTypeValue = "";
        priceVo.memberPriceList = [];
      }
      // 指定分类
      if (priceVo.goodsType === 21) {
        const categoryIdList = [];
        this.categoryShowList.forEach((item) => {
          categoryIdList.push(item.id);
        });
        if (!this.categoryShowList || this.categoryShowList.length === 0) {
          this.$message.error("请选择分类");
          return;
        }
        priceVo.goodsTypeValue = categoryIdList.join(",");
        priceVo.memberPriceList = [];
      }
      if (priceVo.goodsType !== 31) {
        if (!this.rebate) {
          this.$message.error("价格设置不能为空");
          return;
        }
        const format = this.numberFormat(this.rebate, 2);
        if (Number(format.num) <= 0) {
          this.$message.error("价格设置请输入正确数字,最多2位小数");
          return;
        }
        priceVo.rebate = this.rebate / 100;
      }
      // 指定货品
      if (priceVo.goodsType === 31) {
        if (!this.goodsPageTotalList || this.goodsPageTotalList.length === 0) {
          this.$message.error("请选择货品");
          return;
        }
        const { goodsPageList, goodsPageTotalList } = this;
        goodsPageList.forEach((item) => {
          goodsPageTotalList.forEach((gItem) => {
            if (gItem.goodsId == item.goodsId) {
              gItem.price = item.price;
            }
          });
        });
        for (const goods of this.goodsPageTotalList) {
          if (!goods.originalPrice || Number(goods.originalPrice) <= 0) {
            this.$message.error("部分商品无原价，请维护后再保存");
            return;
          }
          if (Number(goods.price) <= 0) {
            this.$message.error("货品金额不能为0且不能为负数");
            return;
          }
          if (Number(goods.price) >= Number(goods.originalPrice)) {
            this.$message.error(`价格方案金额不能大于等于货品原价(${goods.name})`);
            return;
          }
        }
        priceVo.rebate = "";
        priceVo.goodsTypeValue = "";
        priceVo.memberPriceList = this.goodsPageTotalList;
      }
      // 置灰提交按钮 防止重复提交
      this.disabled = true;
      this.$store.dispatch("priceScheme/insertOrUpdatePriceScheme", priceVo).then((data) => {
        // 请求成功
        if (data.code === "0") {
          this.$message.success(data.msg);
          this.priceCancel();
        } else {
          this.$message.error(data.msg);
        }
        this.disabled = false;
      });
    },
    checkCustom(customer) {
      // 必填项校验
      const priceVo = {};
      priceVo.id = this.id;
      priceVo.schemeType = this.price.schemeType;
      priceVo.schemeTypeList = [{ schemeTypeValue: customer.targetIdStr }];
      priceVo.shopId = this.shopId;
      this.$store.dispatch("priceScheme/checkCustom", priceVo).then((data) => {
        // 请求成功
        if (data.code !== "0") {
          this.$message.error("该客户已设置价格方案，请勿重复创建");
          return;
        }
        this.$set(customer, "isActive", !customer.isActive);
        const find = this.customerSelectList.find((selectCustomer) => selectCustomer.schemeTypeValue === customer.targetIdStr);
        if (!find) {
          this.customerSelectList.push({
            name: customer.name,
            targetType: customer.targetType,
            schemeTypeValue: customer.targetIdStr,
          });
        }
      });
    },
    handGoodsPrice(memberPriceList) {
      // 格式化小数位数
      if (memberPriceList) {
        memberPriceList.forEach((item) => {
          const formatPrice = this.formatPrice(item.price, item.goodsPriceDigit);
          this.$set(item, "price", formatPrice);
        });
      }
    },
    // num 输入的数字 scale精确小数位数 negative true负数
    formatPrice(nums, scale, negative) {
      let value = `${nums}`;
      if (negative === true) {
        value = value.replace(/[^\-\d.]/g, "");
      } else {
        value = value.replace(/[^\d.]/g, "");
      }
      value = value.replace(/\\-{2,}/g, "-");
      value = value.replace(/\.{2,}/g, ".");
      value = value.replace(".", "$#$");
      value = value.replace(/\./g, "");
      value = value.replace("$#$", ".");
      const reg = new RegExp(`^(-)?(\\d{1,8})\\.(\\d{0,${scale}}).*$`);
      value = value.replace(reg, "$1$2.$3");
      console.info(value);
      if (value.indexOf(".") < 0 && value !== "" && value !== "-") {
        // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        value = parseFloat(value);
      }
      return value;
    },
    numberValid(num, scales, greaterZeros) {
      let scale = scales;
      let greaterZero = greaterZeros;
      scale = scale || 2;
      if (greaterZero !== false) {
        greaterZero = true;
      }
      const format = this.numberFormat(num, scale);
      if (!format.msg) {
        if (greaterZero && format.num < 0) {
          format.msg = `请输入正确数字,最多${scale}位小数`;
        }
      }
      // 提示
      if (format.msg) {
        this.$message.error(format.msg);
      }
      return format.num;
    },
    numberFormat(nums, scales) {
      let scale = scales;
      let num = "";
      if (nums === 0 || nums) {
        num = nums.toString().trim();
      }
      scale = scale || 2; // 默认两位小数
      let message = "";
      const reg = /^[+-]?\d+(.\d+)?$/;
      if (reg.test(num)) {
        const lengthReg = new RegExp(`^[+-]?\\d{1,7}(.\\d{1,${scale}})?$`);
        if (!lengthReg.test(num)) {
          message = `请输入正确数字,最多${scale}位小数`;
          num = parseFloat(num).toFixed(scale);
        }
      } else {
        message = `请输入正确数字,最多${scale}位小数`;
        num = "";
      }
      return { num, msg: message };
    },

    // 选择删除项
    goodsListSelectionChange(selection) {
      this.goodsSelectedItems = selection;
    },

    // 批量删除
    batchDel() {
      const { goodsPageList, goodsSelectedItems } = this;
      if (!goodsSelectedItems || !goodsSelectedItems.length) {
        this.$message.warning("请选择批量删除商品");
        return;
      }

      this.$confirm("是否删除选中的货品?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "seller-style",
      }).then(() => {
        const goodsList = [];
        goodsPageList.forEach((item) => {
          if (!goodsSelectedItems.some((sItem) => sItem.goodsId == item.goodsId)) {
            goodsList.push(item);
          }
        });
        this.goodsPageList = goodsList;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
body {
  margin: 0;
}
@import "./index.scss";
</style>
